import { useNavigate, Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

export default function AVDesign() {
  const navigate = useNavigate();

  return (
    <main className="bg-[#F3F3F3] text-[#0B132A] min-h-screen">
      <div className="w-full bg-white/70 backdrop-blur border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20 h-14 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-gray-100 hover:bg-gray-200 text-sm transition-colors"
            aria-label="Kembali"
          >
            <BsArrowLeft size={16} />
            Kembali
          </button>
          <span className="text-gray-400">/</span>
          <span className="text-sm text-gray-600">Services</span>
          <span className="text-gray-400">/</span>
          <span className="text-sm font-medium">AV Design</span>
        </div>
      </div>

      <section className="py-10 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-10 xl:px-20">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div
              data-aos="fade-right"
              data-aos-duration="800"
              className="order-2 md:order-1"
            >
              <p className="text-emerald-600 font-semibold tracking-wide">Audiovisual Design</p>
              <h1 className="mt-2 text-2xl md:text-4xl font-semibold leading-tight">
                Perencanaan Sistem Audioviusal yang Presisi
              </h1>
              <p className="mt-4 text-gray-600 leading-relaxed">
                Setiap ruang kerja dan proyek memiliki kebutuhan spesifikasinya masing - masing. 
                Melalui layanan Desain Audiovisual ini kami merancang sistem dengan 
                pendekatan menyeluruh mulai dari pemetaan layar, hingga alur sinyal dan 
                pemilihan perangkat.
              </p>

              <ul className="mt-6 space-y-2">
                {[
                  "memahami kondisi lapangan untuk menghasilkan rancangan yang tepat sasaran.",
                  "perencanaan teknis agar sistem berjalan efisien dan terorganisir.",
                  "daftar perangkat sesuai kebutuhan proyek.",
                  "Gambar kerja & dokumentasi teknis panduan lengkap untuk instalasi dan implementasi.",
                ].map((t, i) => (
                  <li key={i} className="flex items-start gap-2 text-gray-700">
                    <span className="mt-2 inline-block h-1.5 w-1.5 rounded-full bg-emerald-600" />
                    <span>{t}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex items-center gap-3">
                <Link
                  to="/request"
                  className="inline-flex items-center gap-2 rounded-full border border-emerald-600 px-5 py-2.5 text-sm font-medium text-emerald-700 hover:text-white hover:bg-emerald-600 transition-colors"
                >
                  Ajukan Design
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                  </svg>
                </Link>
                <a
                  href="https://wa.me/6289507085550"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-gray-700 border border-gray-300 hover:bg-gray-100 transition-colors"
                >
                  Chat WhatsApp
                </a>
              </div>
            </div>

            <div
              data-aos="fade-left"
              data-aos-duration="800"
              className="order-1 md:order-2"
            >
              <div className="rounded-2xl overflow-hidden bg-white border border-gray-200 shadow-sm">
                <img
                  src="/images/services/avd.png"
                  alt="AV Design Illustration"
                  className="w-full h-[280px] md:h-[420px] object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
